/* src/app/shared/components/circular-confidence-gauge/circular-confidence-gauge.component.scss */
.arc-container {
  --background-color: white;
  aspect-ratio: 1/1;
  width: 100%;
  background-color: var(--background-color);
}
.arc-container .circular-gauge {
  --size: 100%;
  --thickness: 1.25rem;
  --gradient:
    conic-gradient(
      from 225deg,
      #f66e6e 0%,
      #f6ac68 18.75%,
      #f1d367 37.5%,
      #e1f46d 56.25%,
      #97f26c 75%,
      transparent 75%,
      transparent 100%);
  --angle-start: 225deg;
  --angle-end: -45deg;
  --angle-total: calc(var(--angle-start) - var(--angle-end));
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  background: var(--gradient);
  position: relative;
  z-index: 3;
}
.arc-container .circular-gauge::after {
  --inner-circle-size: calc(var(--size) - (var(--thickness) * 2));
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: var(--inner-circle-size);
  height: var(--inner-circle-size);
  border-radius: 50%;
  background-color: var(--background-color);
  clip-path: circle(50% at center);
  z-index: 2;
}
.arc-container .circular-gauge .progress {
  --marker-size: var(--thickness);
  --marker-position-correction: calc(var(--thickness) * (1.414 - 1));
  --marker-container-size: calc((var(--size) + var(--marker-position-correction)) / 1.414);
  --progress-percent: 0;
  --progress-degree: calc(var(--angle-total) * var(--progress-percent) / 100);
  position: absolute;
  top: 50%;
  left: 50%;
  width: var(--marker-container-size);
  height: var(--marker-container-size);
  border-radius: 50%;
  background-color: transparent;
  z-index: 9;
  overflow: visible;
  transform: translate(-50%, -50%) rotate(calc(-90deg + var(--progress-degree)));
  transition: transform 1.5s cubic-bezier(0.68, 0, 0.27, 1.25);
}
.arc-container .circular-gauge .progress::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  display: block;
  width: var(--marker-size);
  height: var(--marker-size);
  border-radius: 50%;
  border: 1.493px solid #757583;
  background: #4a4a4c;
  box-shadow: 0 2.98601px 8.95802px -2.23951px rgba(0, 0, 0, 0.05), 0px 1.493px 3.73251px 0px rgba(0, 0, 0, 0.14);
  box-sizing: border-box;
}
.arc-container .circular-gauge .value-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  padding-bottom: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  justify-content: center;
}
.arc-container .circular-gauge .value-container .value {
  font-size: 3rem;
  height: 1em;
  line-height: 1;
  font-weight: 700;
  color: #242424;
  padding: 0 1rem;
  position: relative;
}
.arc-container .circular-gauge .value-container .value::after {
  content: "?";
  position: absolute;
  top: 0;
  right: 0;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  width: 1rem;
  height: 1rem;
  border: solid thin #242424;
  border-radius: 50%;
  color: #242424;
  text-decoration: none;
}
.arc-container .circular-gauge .value-container .coverage {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  opacity: 0;
  height: 0;
  transition: opacity 1s ease-out, height 0.3s ease-out;
  transition-delay: 2s;
}
.arc-container .circular-gauge .value-container .coverage.show {
  opacity: 1;
  height: 1em;
}
.gauge-label {
  font-size: 0.8rem;
  text-align: center;
  padding-top: 4rem;
}
:host(.circular-confidence-gauge) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=circular-confidence-gauge.component.css.map */
